<app-top-banner>
    <div body class="container privacy-container-box pt-3">
        <h4>Privacy Policy</h4>
        <p>
            This privacy notice discloses the privacy practices for Trade Journaling.
        </p>
        <p>
            MinaTrades Journaling (“us”, “we”, or “our”) operates the https://www.tradejournaling.com
        </p>
        <p>
            This page informs you of our policies regarding the collection, use, and disclosure of personal data when
            you use our Service and the choices you have associated with that data.
        </p>
        <p>
            We use your data to provide and improve the Service. By using the Service, you agree to the collection and
            use of information in accordance with this policy.
        </p>
        <p>
            This privacy notice applies solely to information collected by this web site. It will notify you of the
            following:
        </p>
        <p>
            1. What personally identifiable information is collected from you through the web site, how it is used and
            with whom it may be shared.
        </p>

        <p>
            2. What choices are available to you regarding the use of your data.
        </p>
        <p>
            3. The security procedures in place to protect the misuse of your information.
        </p>
        <p>
            4. How you can correct any inaccuracies in the information.
        </p><br />
        <h3>
            Information Collection, Use, and Sharing
        </h3>
        <p>
            We are the sole owners of the information collected on this site. We only have access to/collect information
            that you voluntarily give us when using the site. We will not sell or rent this information to anyone.
        </p>
        <p>
            We use your information to provide the services of the site. We will not share your information with any
            third party outside of our organization, other than as necessary to fulfill your request. Specifically:
        </p>
        <ul>
            <li>If you explicitly share a trade publicly, certain information about your trade will be made available on
                the site (you can see examples by looking at other shared trades on the site). If you do not wish this
                information to be public, please do not share trades.</li>
        </ul>
        <p>
            Unless you ask us not to, we may contact you via email in the future to tell you about specials, new
            products or services, or changes to this privacy policy.
        </p>
        <p>
            We collect statistical information on web traffic using a third party web analytics service; this may use a
            cookie on your computer, but no user-identifiable information is ever shared with this third party other
            than "typical" web analytics such as IP address, browser, etc.
        </p>
        <p>
            In no event will your individual data be made available to anyone, nor will any personally identifiable
            information be made available or associated with any of the data.
        </p>
        <br />
        <h3>Your Access to and Control Over Information</h3>
        <p>
            You may opt out of any future contacts from us at any time. You can do the following at any time by
            contacting us via
        </p>
        <p>
            email at support support&#64;minatrades.com
        </p>
        <ul>
            <li>Have us delete any data we have about you.</li>
            <li>Express any concern you have about our use of your data.</li>
        </ul>
        <br />
        <h3>
            Security
        </h3>
        <p>
            We take precautions to protect your information. When you submit sensitive information via the website, your
            information is protected both online and offline.
        </p>
        <p>
            Wherever we collect sensitive information (such as your trade data), that information is encrypted and
            transmitted to us in a secure way.
        </p>
        <p>
            If you feel that we are not abiding by this privacy policy, please contact us immediately via email at
            support&#64;minatrades.com
        </p>
        <br>
    </div>
</app-top-banner>
